import { Action, Reducer } from "redux";
import { ClaimTypeState, ClaimTypeTypes, ClaimTypeActionTypes } from "./claimTypeTypes";

export const INITIAL_STATE: ClaimTypeState = {
	claimType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const claimTypeReducer: Reducer<ClaimTypeState> = (state: ClaimTypeState = INITIAL_STATE, action: Action) => {
	const actionTypes = action as ClaimTypeActionTypes;
	switch (actionTypes.type) {
		case ClaimTypeTypes.GET_CLAIM_TYPE:
			return {
				...state,
				claimType: { ...state.claimType, isLoading: true },
			};
		case ClaimTypeTypes.SAVE_CLAIM_TYPE:
			return {
				...state,
				claimType: {
					...state.claimType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case ClaimTypeTypes.RESET_REDUCER_CLAIM_TYPE:
			return {
				...state,
				claimType: INITIAL_STATE.claimType,
			};
		default:
			return state;
	}
};

export default claimTypeReducer;
